import { render, staticRenderFns } from "./PublicTeamList.vue?vue&type=template&id=c2f5ce8a&"
import script from "./PublicTeamList.vue?vue&type=script&lang=js&"
export * from "./PublicTeamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports